export const strategyColors = {
  BigBetBadUserStrategy: '#f59e0b',
  TakeProfitStrategy: '#10b981',
  MarketMakingStrategy: '#3b82f6',
  ArbitrageStrategy: '#ef4444'
};

export function getStrategyColor(strategy) {
  return strategyColors[strategy] || '#6b7280';
}
